import React from 'react'
import SearchCars from "../components/SearchCars";
import { Helmet } from 'react-helmet';

function CabinFilters() {

  const pageTitle = "Филтри за кабина - Пребарување на автомобилски филтри за кабина | Filtri za polen za tvojot avtomobil";
  const pageDescription = "Пронајди филтри за кабина за твоето возило. Погледни ги различните опции за филтри за клима за твојот автомобили и диши чист воздух. Golem izbor na filtri za klima.";
  const pageKeywords = "филтри за кабина, филтри за полен, филтри за автомобили, авто филтри, филтри за клима за автомобил, автомобилски делови, моторни филтри";


  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta name="keywords" content={pageKeywords} />
      </Helmet>

      <div className='flex flex-col justify-start items-center'>
        <h1 className='text-4xl font-bold mb-8'>Филтри за кабина (полен филтер)</h1>
        <SearchCars category={5} allFilters={false} />
      </div>
    </>
  )
}

export default CabinFilters
